<template>
  <div
    v-if="state"
    class="san-infinite-hits"
  >
    <slot
      v-if="showButtonPrev"
      name="buttonPrev"
      :refine-previous="refinePrev"
      :page="state.results.page"
      :is-first-page="state.isFirstPage"
    >
      <SanButton
        class="san-infinite-hits--button-prev"
        :class="[state.isFirstPage && 'san-infinite-hits--button-prev--disabled']"
        :disabled="state.isFirstPage"
        @click="refinePrev()"
      >
        Previous results
      </SanButton>
    </slot>

    <slot
      :items="state.items"
      :results="state.results"
      :banner="state.banner"
      :is-last-page="state.isLastPage"
      :refine-previous="refinePrev"
      :refine-next="refineNext"
      :refine="refineNext"
      :insights="state.insights"
      :send-event="state.sendEvent"
    >
      <template v-if="showBanner && state.banner && state.banner.image.urls[0].url">
        <slot
          name="banner"
          :banner="state.banner"
        >
          <aside class="san-infinite-hits--banner">
            <a
              v-if="state.banner.link"
              :href="state.banner.link.url"
              :target="state.banner.link.target"
              class="san-infinite-hits--banner--link"
            >
              <img
                :src="state.banner.image.urls[0].url"
                :alt="state.banner.image.title"
                class="san-infinite-hits--banner--image"
              >
            </a>
            <img
              v-else
              :src="state.banner.image.urls[0].url"
              :alt="state.banner.image.title"
              class="san-infinite-hits--banner--image"
            >
          </aside>
        </slot>
      </template>
      <ol class="san-infinite-hits--list">
        <li
          v-for="(item, index) in state.items"
          :key="item.objectID"
          class="san-infinite-hits--list--item"
          @click="state.sendEvent('click:internal', item, 'Hit Clicked')"
          @auxclick="state.sendEvent('click:internal', item, 'Hit Clicked')"
        >
          <slot
            name="item"
            :item="item"
            :index="index"
            :insights="state.insights"
            :send-event="state.sendEvent"
          >
            objectID: {{ item.objectID }}, index: {{ index }}
          </slot>
        </li>
      </ol>

      <!-- v-if="!state.isLastPage" -->
      <div
        v-intersection="refineNext"
        class="san-infinite-hits--sentinel next"
      />

      <slot
        v-if="showButtonNext"
        name="buttonNext"
        :refine-next="refineNext"
        :refine="refineNext"
        :page="state.results.page"
        :is-last-page="state.isLastPage"
      >
        <SanButton
          class="san-infinite-hits--button-next"
          :class="[state.isLastPage && 'san-infinite-hits--button-next--disabled']"
          :disabled="state.isLastPage"
          @click="refineNext()"
        >
          Next results
        </SanButton>
      </slot>
    </slot>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue' // eslint-disable-line
import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
import { useConnector } from '@/composables'

defineOptions({ name: 'SanInfiniteHits' })
const props = defineProps({
  showBanner: { type: Boolean, default: true },
  showButtonPrev: { type: Boolean, default: false },
  showButtonNext: { type: Boolean, default: false },
  escapeHTML: { type: Boolean, default: true },
  transformItems: { type: Function, default: undefined },
  cache: { type: Object, default: undefined }
})

const state = useConnector(connectInfiniteHits, {
  $$widgetType: 'ais.infiniteHits',
  showBanner: props.showBanner,
  showPrevious: props.showButtonPrev,
  escapeHTML: props.escapeHTML,
  transformItems: props.transformItems,
  cache: props.cache
})

const refinePrev = () => state.value.showPrevious()
const refineNext = () => state.value.showMore()
</script>
